export const TOKEN_KEY_NAME = 'BOOMPAY_TOKEN';
export const DEFAULT_TIMEZONE = 3;
// export const AVALABLE_CURRENCIES = [
//   'KZT',
//   'UAH',
//   'UZS',
//   'AZN',
//   'TRY',
//   'KGS',
//   'RUB',
//   'TJS',
//   'ARS',
//   'USD',
//   'EUR',
//   'PHP',
//   'USDT',
//   'USDC',
//   'BTC',
//   'ETH',
//   'TON',
//   'XRP',
//   'LTC',
// ];
